@if (!articleUuid) {
  <p class="text-muted small mb-0">Guardá el artículo para poder subir capturas.</p>
} @else {
  <div class="row g-2 align-items-end mb-3">
    <div class="col-md-5">
      <label class="form-label small text-muted mb-1">Pie de captura</label>
      <input type="text" class="form-control form-control-sm" [(ngModel)]="caption" placeholder="Opcional">
    </div>
    <div class="col-md-7">
      <label class="form-label small text-muted mb-1">Archivo</label>
      <input type="file" class="form-control form-control-sm" accept="image/*,.pdf"
        [disabled]="uploading" (change)="onFileSelected($event)">
    </div>
  </div>

  @if (documents.length === 0) {
    <p class="text-muted small">Sin capturas todavía.</p>
  } @else {
    <ul class="list-group list-group-flush">
      @for (row of documents; track row.uuid) {
        <li class="list-group-item px-0 d-flex justify-content-between align-items-start gap-2">
          <div class="flex-grow-1">
            <div class="fw-medium">{{ row.caption || row.document?.fileName || 'Adjunto' }}</div>
            <code class="small text-muted">{{ row.uuid }}</code>
            @if (viewUrl(row); as url) {
              <div class="mt-1">
                <a [href]="url" target="_blank" rel="noopener">Ver</a>
                <button type="button" class="btn btn-link btn-sm p-0 ms-2" (click)="copyMd(row)">
                  Copiar markdown
                </button>
              </div>
            }
          </div>
          <button type="button" class="btn btn-sm btn-outline-danger" (click)="remove(row)">
            <i class="fas fa-trash"></i>
          </button>
        </li>
      }
    </ul>
  }
}
